import type SdNotification from '@solid-design-system/components/dist-versioned/components/notification/notification';
import { firstValueFrom, Observable } from 'rxjs';

export async function displayNotification(
  message: string | Observable<string> | null,
  variant: SdNotification['variant'],
  options:
    | {
        closable?: boolean;
        durationInMs?: number;
      }
    | undefined = { closable: true, durationInMs: 10000 }
): Promise<void> {
  if (message === null) {
    return;
  }

  if (typeof message !== 'string') {
    message = await firstValueFrom(message);
  }

  const notification: SdNotification = document.createElement('sd-4-5-1-notification') as SdNotification;
  notification.textContent = message;
  notification.variant = variant;

  if (options) {
    if (options.closable) {
      notification.closable = true;
    }

    if (options.durationInMs !== undefined) {
      notification.duration = options.durationInMs;
      notification.durationIndicator = true;
    }
  }

  notification.toast();
}

export const NotificationUtils = {
  displayNotification: displayNotification,
};
